export default __webpack_public_path__ + "static/media/book-thumbnail.13254b25.png";